import { useCallback } from 'react';
import useContentSearch from '../prosemirror/utils/useContentSearch';
import ContentTypeahead from './ContentTypeahead';
import { jsx as _jsx } from "react/jsx-runtime";
function ContentTypeaheadContainer({
  // @ts-ignore ts-migrate FIXME
  ErrorState,
  // @ts-ignore ts-migrate FIXME
  EmptyState,
  // @ts-ignore ts-migrate FIXME
  onChange,
  // @ts-ignore ts-migrate FIXME
  portalId,
  // @ts-ignore ts-migrate FIXME
  searchPlaceHolder,
  // @ts-ignore ts-migrate FIXME
  search,
  // @ts-ignore ts-migrate FIXME
  transformData
}) {
  const [__data, searchQuery, setSearchQuery, options, isLoading] = useContentSearch(search, transformData);
  const handleSearch = useCallback(e => setSearchQuery(e.target.value), [setSearchQuery]);
  return /*#__PURE__*/_jsx(ContentTypeahead, {
    portalId: portalId,
    ErrorState: ErrorState,
    EmptyState: EmptyState,
    search: searchQuery,
    handleSearch: handleSearch,
    isLoading: isLoading
    // @ts-ignore ts-migrate FIXME
    ,
    options: options,
    searchPlaceHolder: searchPlaceHolder,
    onChange: onChange
  });
}
export default ContentTypeaheadContainer;